import React from 'react';
import { ReactComponent as ModalIcon } from '../../images/Icons/orange_level.svg';

export default function ModalsHeaderNewLevelOrange() {

  return (
    <div>
      <div className="ModalsHeader orange">
        <div>
          <ModalIcon />
        </div>
      </div>
      <div className="ModalsHeaderShadow"></div>
    </div>
  );
}
